import axios from "axios";
import appConfig from '../config'
import sessionStore from "@/stores/AuthStore";
import router from '@/router'
const apiUrl = appConfig.apiUrl

axios.interceptors.response.use(response => {
    return response;
}, error => {
    if (error.response.status === 401) {
        router.push('/logout')
    }
    return Promise.reject(error);
});
//TODO change file name to base.ts to enable typescript
export default {
    get (slug, params = {}) {
        const config = this.getConfig()
        config['params'] = params ? params : {}
        //console.log('request params from axios', params)
        return axios.get(`${apiUrl}${slug}`, config)
    },

    put (slug, data) {
        const config = this.getConfig()
        return axios.put(`${apiUrl}${slug}`, data, config)
    },

    postNoAuth (slug, data) {
        return axios.post(`${apiUrl}${slug}`, data)
    },


    post (slug, data) {
        const config = this.getConfig()
        return axios.post(`${apiUrl}${slug}`, data, config)
    },

    delete (slug, data) {
        return axios.delete(`${apiUrl}${slug}`, {headers: {Authorization:`Bearer ${sessionStore.state.accessToken}`}, data})
    },

    getConfig () {
        return { headers: {Authorization:`Bearer ${sessionStore.state.accessToken}` }}
    }
}